export default "__VITE_ASSET__CrnucnK6__"